<div [lang]="translateService.currentLang">
  <alert></alert>
  <app-header></app-header>
  <div class="container-fluid">
    <router-outlet></router-outlet>
  </div>
    <app-footer></app-footer>
</div>
